<template>
	<div class="grid grid-cols-3 gap-4">
		<div class="col-span-2">
			<MessageChatsWazzupSection
			/>
		</div>
		<div class="col-span-1">
			<InfoChatWazzupSection
			/>
		</div>
	</div>
</template>

<script>
import MessageChatsWazzupSection from "@/components/whatsapp/MessageChatsWazzupSection";
import InfoChatWazzupSection from "@/components/whatsapp/InfoChatWazzupSection";

export default {
	// mixins: ,
	name: "OpenChatWhatsapp",
	components: {
		MessageChatsWazzupSection,
		InfoChatWazzupSection,
	},
	data() {
		return {
			// idChat: null,
		};
	},
	computed: {

	},
	methods: {
		
	},
	async mounted() {
		// this.idChat = this.$route.params.id;
	}
}
</script>

<style lang="scss" scoped>
	.whatsappMain {
		display: flex;
		width: 100%;
	}

</style>